import React from "react";
import { Author } from "components/article/articleContent";
import { Text } from "@indeed/ifl-components";
import { ArticleHeroCreditStyles } from "styles/common";
import type { Contributor } from "types/globals";

const renderAuthor = (
  contributor: Contributor,
  isLast: Boolean,
  hasOxfordComma = false
) => (
  <React.Fragment key={contributor.contributorName}>
    <Author
      name={contributor.contributorName}
      link={contributor.contributorLink}
    />
    {!isLast && !hasOxfordComma && <Text>,&nbsp;</Text>}
  </React.Fragment>
);

/* Formats contributor list for article hero */
const parseArticleHeroContributors = (contributorList: Contributor[]) => {
  const contributorCount = contributorList.length;

  if (contributorCount === 0) {
    return null;
  }

  if (contributorCount === 1) {
    return [renderAuthor(contributorList[0], true)];
  }

  const lastIdx = contributorCount - 1;
  return contributorList.map((contributor, index) => {
    const isLast = index === lastIdx;
    const isSecondToLast = index === lastIdx - 1;
    const hasOxfordComma = contributorCount === 2;

    if (isSecondToLast) {
      return renderAuthor(contributor, isLast, hasOxfordComma);
    }

    if (isLast) {
      return (
        <React.Fragment key={contributor.contributorName}>
          <Text sx={{ ...ArticleHeroCreditStyles }}>&nbsp;and&nbsp;</Text>
          {renderAuthor(contributor, isLast)}
        </React.Fragment>
      );
    }

    return renderAuthor(contributor, isLast);
  });
};

export default parseArticleHeroContributors;
